import { connect } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { DownloadManagerState } from '../../DownloadManager/reducer';
import DownloadManagerUtils from '../../../utils/downloadManager';

interface DownloadsDriveItemListPageProps extends AbstractDriveItemListPageProps {
	downloadManager: DownloadManagerState;
}

class DownloadsDriveItemListPage extends AbstractDriveItemListPage<DownloadsDriveItemListPageProps> {

	headerLabel = 'messages.downloads';
	noItemsLabel = 'messages.no_downloads';
	hasPageTitle = true;

	initializeView(props: DownloadsDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		const { downloadManager, driveList } = this.props;
		const downloadedItems = DownloadManagerUtils.getDownloadedItems(downloadManager).reverse();
		const downloadingItems = DownloadManagerUtils.getDownloadingItems(downloadManager).reverse();

		const displayableDownloadedItems = downloadedItems
			.filter(id => driveList.driveItems[id] && driveList.driveItems[id].isInGallery
				&& DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, id));
		const displayableDownloadingItems = downloadingItems
			.filter(id => driveList.driveItems[id] && driveList.driveItems[id].isInGallery && DownloadManagerUtils.isRequestedItem(downloadManager, id));

		return [...displayableDownloadedItems, ...displayableDownloadingItems];
	}

	get sliderKey(): string {
		return this.props.params.origin;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { downloadManager } = state;
	return { downloadManager };
};

export default connect(mapStateToProps)(DownloadsDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Downloads.tsx